import { useEffect, useMemo, useState } from "react";
import { filterObjectByKeys, disabledFilterTooltipTitle } from "./DreamSearchFilter";
import debounce from "lodash/debounce";
import { useDreamSearchContext } from "../../../DreamSearchContext";
import { customerPaymentOptionFriendlyNameMap } from "@portal/app/_common/data/enumValueMaps";
import isEmpty from "lodash/isEmpty";
import { EnumMultiSelectChipFilter } from "@portal/app/manage/_components/DreamTable";
import { FilterComponentProps } from "./DreamSearchFilter";

export const PaymentOptionsFilterComponent = ({
  value,
  setValue,
  setHasOptions,
}: FilterComponentProps<GQL.PaymentOptionType[]>) => {
  const { filterSettings } = useDreamSearchContext();
  const [localValue, setLocalValue] = useState<GQL.PaymentOptionType[]>(value);
  const [availableOptions] = useState(
    filterObjectByKeys(customerPaymentOptionFriendlyNameMap, filterSettings?.paymentOptionType)
  );

  const debounceSetValue = useMemo(
    () => debounce((localValue: GQL.PaymentOptionType[]) => setValue(localValue), 500),
    [setValue]
  );

  useEffect(() => {
    if (filterSettings) {
      setHasOptions(Object.keys(availableOptions).length > 0);
    }
  }, [availableOptions, filterSettings, setHasOptions]);

  return (
    <EnumMultiSelectChipFilter<GQL.PaymentOptionType>
      label="Payment options"
      value={localValue}
      id="payment-options"
      setValue={(value) => {
        const newValue = isEmpty(value) ? null : value;
        setLocalValue(newValue);
        debounceSetValue(newValue);
      }}
      enumToFriendlyMap={availableOptions}
      disabledTooltipTitle={disabledFilterTooltipTitle}
    />
  );
};
